import { useTranslation } from 'react-i18next';
import { NotificationPanel } from './notificationPanel/NotificationPanel';
import { useUpdateNotificationContentPanel } from './notificationPanel/utility/useUpdateNotificationContentPanel';

const UpdateNotificationContentPanel = ({
  hearingId,
  notificationTypeValue,
}) => {
  const { t: translator } = useTranslation();

  const {
    isPanelOpen,
    onDismiss,
    onSave,
    onDownloadNotification,
    onSendNotification,
    notificationContent,
    notificationType,
    isFetching,
  } = useUpdateNotificationContentPanel(hearingId, notificationTypeValue);

  return (
    <NotificationPanel
      content={notificationContent}
      notificationType={notificationType}
      isOpen={isPanelOpen}
      onClose={onDismiss}
      onClickSaveButton={onSave}
      onDownloadNotification={onDownloadNotification}
      onSendNotification={onSendNotification}
      headerText={translator('components.notificationPanel.headerText')}
      isFetching={isFetching}
    />
  );
};

export { UpdateNotificationContentPanel };
